// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScienceCloudCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm10 8c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-14.05-.66a.285.285 0 0 0 .172-.235c.15-1.681 1.626-3.001 3.425-3.001 1.266 0 2.373.653 2.97 1.626a.278.278 0 0 0 .257.131c.07-.005.14-.007.21-.007 1.52 0 2.75 1.175 2.75 2.625s-1.23 2.625-2.75 2.625H8.798c-1.139 0-2.062-.882-2.062-1.969 0-.799.498-1.487 1.215-1.795z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgScienceCloudCircle;
